import { render } from "./Transport.vue?vue&type=template&id=2dd9a8c4"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"

import exportComponent from "/data01/virt24076/domeenid/www.rallyestonia.ee/htdocs/ui/template/rallyestonia/moduleTmpl/shop/VueBasket/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__